import React from 'react';
import { Routes, Route } from 'react-router-dom';

import asyncComponent from './components/async.component';
import Classic from './layouts/layout-classic/layout-classic.component';
import NoLayout from './layouts/layout-none/layout-none.component';

// DASHBOARD ROUTE
const AsyncDashboard = asyncComponent(() => import('./containers/screens/dashboard/dashboard.component'));

//ADMIN
const AsysncCategory = asyncComponent(() => import('./containers/screens/category/category.component'));
const AsysncAddcategory = asyncComponent(
    () => import('./containers/screens/category/AddCategory/addCategory.component'),
);
const AsysncExtraFeature = asyncComponent(() => import('./containers/screens/extra-feature/extra-feature.component'));
const AsysncAddExtraFeature = asyncComponent(
    () => import('./containers/screens/extra-feature/addExtraFeature/addExtraFeature.component'),
);
const AsysncLocality = asyncComponent(() => import('./containers/screens/locality/locality.component'));
const AsysncAddLocality = asyncComponent(
    () => import('./containers/screens/locality/addLocality/addLocality.component'),
);
const AsysncAdvertiseList = asyncComponent(() => import('./containers/screens/advertise/advertiseList.component'));
const AsyncFormBasicSettings = asyncComponent(
    () => import('./containers/screens/basic-settings/formBasicSetting/formBasicSetting.component'),
);
const AsyncAddBasicSettings = asyncComponent(
    () => import('./containers/screens/basic-settings/AddBasicSetting/AddBasicSetting.component'),
);
const AsyncNotification = asyncComponent(() => import('./containers/screens/notifications/notifications.component'));
const AsyncCustomNotification = asyncComponent(
    () => import('./containers/screens/custom-notification/custom-notification.component'),
);
const AsyncPayments = asyncComponent(() => import('./containers/screens/payments/payments.component'));

// USERS ROUTE
const AsyncUsers = asyncComponent(() => import('./containers/screens/users/usersList.component'));
const AsyncUserDetails = asyncComponent(() => import('./containers/screens/users/userDetails.component'));
const AsyncAddUser = asyncComponent(() => import('./containers/screens/users/addUser.component'));

//ADMIN USERS ROUTE
const AsyncAdminUsers = asyncComponent(() => import('./containers/screens/admin-user/usersList.component'));
const AsyncAdminUserDetails = asyncComponent(() => import('./containers/screens/admin-user/userDetails.component'));
const AsyncAdminAddUser = asyncComponent(() => import('./containers/screens/admin-user/addUser.component'));

// REORDER ROUTE
const AsyncReorder = asyncComponent(() => import('./containers/screens/reorder/reorder.component'));
const AsyncReorderLocality = asyncComponent(
    () => import('./containers/screens/reorder/reorder-locality/reorder-locality.component'),
);
const AsyncReorderCategory = asyncComponent(
    () => import('./containers/screens/reorder/reorder-category/reorder-category.component'),
);
const AsyncReorderExtraFeature = asyncComponent(
    () => import('./containers/screens/reorder/reorder-extra-feature/reorder-extra-feature.component'),
);
const AsyncReorderQuestions = asyncComponent(
    () => import('./containers/screens/reorder/reorder-question/reorder-question.component'),
);
const AsyncReorderOptions = asyncComponent(
    () => import('./containers/screens/reorder/reorder-option/reorder-option.component'),
);

//QUESTIONS OR ATTRIBUTE ROUTE
const AsyncQuestionList = asyncComponent(() => import('./containers/screens/question/questionList.component'));
const AsyncAddEditQuestion = asyncComponent(() => import('./containers/screens/question/addQuestion.component'));
const AsyncViewQuestion = asyncComponent(() => import('./containers/screens/question/questionDetails.component'));
const AsyncAssignQuestion = asyncComponent(
    () => import('./containers/screens/question-assign/assignQuestion.component'),
);

const AsyncAddAds = asyncComponent(() => import('./containers/screens/advertise/addAdvertise.component'));
const AsyncAdsDetails = asyncComponent(() => import('./containers/screens/advertise/adsDetails.component'));

// AUTHENTICATION ROUTES
const AsyncLogin = asyncComponent(() => import('./containers/authentication/login/login.component'));
const AsyncChangePassword = asyncComponent(
    () => import('./containers/authentication/change-password/change-password.component'),
);

//SUPPORT
const AsyncSupport = asyncComponent(() => import('./containers/screens/support/support.component'));

const AsyncNotFound = asyncComponent(() => import('./containers/not-found/not-found.component'));

//Extra Feature Group
const AsyncExtraFeatureGroup = asyncComponent(
    () => import('./containers/screens/extra-feature-group/extra-feature-group.component'),
);

const AsyncAddEditExtraFeatureGroup = asyncComponent(
    () =>
        import(
            './containers/screens/extra-feature-group/add-edit-extra-feature-group/add-edit-extra-feature-group.component'
        ),
);

//Property Feature Group
const AsyncPropertyFeatureGroup = asyncComponent(
    () => import('./containers/screens/property-feature-group/property-feature-group.component'),
);

const AsyncAddEditPropertyFeatureGroup = asyncComponent(
    () =>
        import(
            './containers/screens/property-feature-group/add-edit-property-feature-group/add-edit-property-feature-group.component'
        ),
);

const ClassicLayout = props => <Classic>{props.children}</Classic>;

const AppRoutes = ({ childProps, layout }) => {
    let ActiveLayout = ClassicLayout;

    return (
        <Routes>
            <Route
                path="/"
                element={
                    <ActiveLayout>
                        <AsyncDashboard {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/login"
                element={
                    <NoLayout>
                        <AsyncLogin {...childProps} />
                    </NoLayout>
                }
            />
            <Route
                path="/basic-settings/form"
                element={
                    <ActiveLayout>
                        <AsyncFormBasicSettings {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/notification"
                element={
                    <ActiveLayout>
                        <AsyncNotification {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/broadcast"
                element={
                    <ActiveLayout>
                        <AsyncCustomNotification {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/transactions"
                element={
                    <ActiveLayout>
                        <AsyncPayments {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/change-password"
                element={
                    <ActiveLayout>
                        <AsyncChangePassword {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/category"
                element={
                    <ActiveLayout>
                        <AsysncCategory {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/category/add"
                element={
                    <ActiveLayout>
                        <AsysncAddcategory {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/category/edit/:catId"
                element={
                    <ActiveLayout>
                        <AsysncAddcategory {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/extra-feature"
                element={
                    <ActiveLayout>
                        <AsysncExtraFeature {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/extra-feature/add"
                element={
                    <ActiveLayout>
                        <AsysncAddExtraFeature {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/extra-feature/edit/:featureId"
                element={
                    <ActiveLayout>
                        <AsysncAddExtraFeature {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/locality"
                element={
                    <ActiveLayout>
                        <AsysncLocality {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/locality/add"
                element={
                    <ActiveLayout>
                        <AsysncAddLocality {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/locality/edit/:localityId"
                element={
                    <ActiveLayout>
                        <AsysncAddLocality {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/advertise-list"
                element={
                    <ActiveLayout>
                        <AsysncAdvertiseList {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/users"
                element={
                    <ActiveLayout>
                        <AsyncUsers {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/users/add"
                element={
                    <ActiveLayout>
                        <AsyncAddUser {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/users/edit/:userId"
                element={
                    <ActiveLayout>
                        <AsyncAddUser {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/users/view/:userId"
                element={
                    <ActiveLayout>
                        <AsyncUserDetails {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/admin-users"
                element={
                    <ActiveLayout>
                        <AsyncAdminUsers {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/admin-users/add"
                element={
                    <ActiveLayout>
                        <AsyncAdminAddUser {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/admin-users/edit/:userId"
                element={
                    <ActiveLayout>
                        <AsyncAdminAddUser {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/admin-users/view/:userId"
                element={
                    <ActiveLayout>
                        <AsyncAdminUserDetails {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/reorder"
                element={
                    <ActiveLayout>
                        <AsyncReorder {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/reorder-locality"
                element={
                    <ActiveLayout>
                        <AsyncReorderLocality {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/reorder-category"
                element={
                    <ActiveLayout>
                        <AsyncReorderCategory {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/reorder-extra-feature"
                element={
                    <ActiveLayout>
                        <AsyncReorderExtraFeature {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/reorder-questions"
                element={
                    <ActiveLayout>
                        <AsyncReorderQuestions {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/advertise/add"
                element={
                    <ActiveLayout>
                        <AsyncAddAds {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/advertise/edit/:advertiseId"
                element={
                    <ActiveLayout>
                        <AsyncAddAds {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/advertise/view/:advertiseId"
                element={
                    <ActiveLayout>
                        <AsyncAdsDetails {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/question-list"
                element={
                    <ActiveLayout>
                        <AsyncQuestionList {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/question/edit/:questionId"
                element={
                    <ActiveLayout>
                        <AsyncAddEditQuestion {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/question/add"
                element={
                    <ActiveLayout>
                        <AsyncAddEditQuestion {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/question/view/:questionId"
                element={
                    <ActiveLayout>
                        <AsyncViewQuestion {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/question/assign/:categoryId"
                element={
                    <ActiveLayout>
                        <AsyncAssignQuestion {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/question/assign"
                element={
                    <ActiveLayout>
                        <AsyncAssignQuestion {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/support"
                element={
                    <ActiveLayout>
                        <AsyncSupport {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/support/:categoryId/:receiverId/:threadId"
                element={
                    <ActiveLayout>
                        <AsyncSupport {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/reorder-options"
                element={
                    <ActiveLayout>
                        <AsyncReorderOptions {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/feature-group/extra"
                element={
                    <ActiveLayout>
                        <AsyncExtraFeatureGroup {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/feature-group/extra/add"
                element={
                    <ActiveLayout>
                        <AsyncAddEditExtraFeatureGroup {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/feature-group/extra/edit/:id"
                element={
                    <ActiveLayout>
                        <AsyncAddEditExtraFeatureGroup {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/feature-group/property"
                element={
                    <ActiveLayout>
                        <AsyncPropertyFeatureGroup {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/feature-group/property/add"
                element={
                    <ActiveLayout>
                        <AsyncAddEditPropertyFeatureGroup {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="/feature-group/property/edit/:id"
                element={
                    <ActiveLayout>
                        <AsyncAddEditPropertyFeatureGroup {...childProps} />
                    </ActiveLayout>
                }
            />
            <Route
                path="*"
                element={
                    <ActiveLayout>
                        <AsyncNotFound {...childProps} />
                    </ActiveLayout>
                }
            />
        </Routes>
    );
};

export default AppRoutes;
